export default function FooterSection() {
  return (
    <footer className="bg-[#f0ede8] border-t border-[#1a1a1a]/8">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24">
          {/* Brand */}
          <div className="lg:w-1/3">
            <p
              className="text-[#1a1a1a] text-xl tracking-[0.2em] font-light mb-3"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              TEVANASHI
            </p>
            <p className="text-[#b4a078] text-[10px] tracking-[0.3em] uppercase mb-5">The All-Star Partner</p>
            <p className="text-[#1a1a1a]/40 text-xs leading-relaxed">
              各界のトップクラス人材が、あなたの事業の「並走チーム」として機能する。
              立ち上げの準備から成長期まで。一過性のコンサルではなく、成功を共有する実戦集団。
            </p>
          </div>

          {/* Nav columns */}
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <p className="text-[#1a1a1a]/30 text-[9px] tracking-[0.3em] uppercase mb-4">Service</p>
              <div className="space-y-3">
                {['Our Team', 'Commitment', 'Evidence', 'Infographic'].map((item) => (
                  <a key={item} href={`#${item.toLowerCase()}`} className="block text-[#1a1a1a]/50 hover:text-[#1a1a1a] text-xs transition-colors cursor-pointer">
                    {item}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[#1a1a1a]/30 text-[9px] tracking-[0.3em] uppercase mb-4">Expertise</p>
              <div className="space-y-3">
                {['Hairdresser', 'Marketing & EC', 'AI Consulting', 'Grants & Finance', 'Design'].map((item) => (
                  <span key={item} className="block text-[#1a1a1a]/50 text-xs">{item}</span>
                ))}
              </div>
            </div>
            <div>
              <p className="text-[#1a1a1a]/30 text-[9px] tracking-[0.3em] uppercase mb-4">Contact</p>
              <div className="space-y-3">
                <a href="#cta" className="block text-[#1a1a1a]/50 hover:text-[#1a1a1a] text-xs transition-colors cursor-pointer">無料相談</a>
                <span className="block text-[#1a1a1a]/50 text-xs">お問い合わせ</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-[#1a1a1a]/8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#1a1a1a]/30 text-[10px]">
            &copy; 2026 TEVANASHI. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-[#1a1a1a]/30 text-[10px] cursor-pointer hover:text-[#1a1a1a]/60 transition-colors">プライバシーポリシー</span>
            <span className="text-[#1a1a1a]/30 text-[10px] cursor-pointer hover:text-[#1a1a1a]/60 transition-colors">利用規約</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
